import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { useServerErrorActions } from 'contexts/ServerErrorContext';
import { purchasingModel, currenciesModel } from 'models';
import { BUTTON_TYPE, PURCHASING_VALUES } from 'pages/settings/PurchasingFlowSettings/constants';

import { Image } from '../style';
import { PreviewWrapper, ButtonsWrapper, ButtonContainer } from './style';

export function CheckoutInfoPreview({ infoButton, checkoutButtonInitial }) {
  const [checkoutButton, setCheckoutButton] = useState(false);
  const { handleServerError } = useServerErrorActions();

  useEffect(() => {
    if (!checkoutButtonInitial) {
      handleUpdate();
    } else setCheckoutButton(checkoutButtonInitial);
  }, [checkoutButtonInitial]);

  const handleUpdate = () =>
    purchasingModel.getSettings().then(({ purchasingFlow }) => {
      if (purchasingFlow === PURCHASING_VALUES.checkout) {
        currenciesModel
          .getBuyButtons()
          .then(list => list.find(({ buttonType }) => buttonType === BUTTON_TYPE.CHECKOUT))
          .then(checkout => setCheckoutButton(checkout))
          .catch(handleServerError);
      }
    });

  return (
    <PreviewWrapper>
      <ButtonsWrapper>
        <ButtonContainer className="info" style={{ backgroundColor: infoButton.color }}>
          <Image src={infoButton.iconUrl} />
        </ButtonContainer>
        {checkoutButton && (
          <ButtonContainer className="checkout" style={{ backgroundColor: checkoutButton.color }}>
            <Image src={checkoutButton.iconUrl} />
          </ButtonContainer>
        )}
      </ButtonsWrapper>
    </PreviewWrapper>
  );
}

CheckoutInfoPreview.propTypes = {
  infoButton: PropTypes.shape({
    color: PropTypes.string,
    iconUrl: PropTypes.string,
  }).isRequired,
  checkoutButtonInitial: PropTypes.shape({
    color: PropTypes.string,
    iconUrl: PropTypes.string,
  }),
};

CheckoutInfoPreview.defaultProps = {
  checkoutButtonInitial: null,
};
